"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var mathHelper_1 = require("./mathHelper");
var NumberFormatter = /** @class */ (function () {
    function NumberFormatter() {
    }
    NumberFormatter.getCurrencyFormattedNumber = function (value) {
        if (value === null) {
            return '';
        }
        return '$' + this.getFormattedNumber(value); // eslint-disable-line prefer-template
    };
    NumberFormatter.getFormattedNumber = function (value) {
        if (value === 0) {
            return 0;
        }
        if (!value) {
            return '';
        }
        if (!this.isInt(this.scrubFormatting(value))) {
            return ''; // if it's not a number after scrubbing formatting, just return empty.
        }
        var roundedValue = mathHelper_1.default.roundNumber(value, 2); // round if more than 2 decimal points
        roundedValue = roundedValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); // add commas for 1,000's. RegEx from http://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
        var roundedValueContainsDecimalPlace = (roundedValue.indexOf('.') !== -1);
        if (roundedValueContainsDecimalPlace) {
            var numbersToTheRightOfDecimal = roundedValue.split('.')[1];
            switch (numbersToTheRightOfDecimal.length) {
                case 0:
                    return roundedValue.replace('.', ''); // no decimal necessary since no numbers after decimal
                case 1:
                    return "".concat(roundedValue, "0");
                default:
                    return roundedValue;
            }
        }
        return roundedValue;
    };
    NumberFormatter.isInt = function (n) {
        if (n === '' || n === null) {
            return false;
        }
        return n % 1 === 0;
    };
    NumberFormatter.scrubFormatting = function (value) {
        return value.toString().replace('$', '').replace(',', '').replace('.', '');
    };
    return NumberFormatter;
}());
exports.default = NumberFormatter;
//# sourceMappingURL=numberFormatter.js.map


/** WEBPACK FOOTER **
 ** ./src/utils/numberFormatter.js
 **/